import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <div className="border-b border-border bg-background">
      <div className="container-site py-3 flex items-center gap-2 text-[10px] tracking-[0.16em] uppercase font-semibold text-muted-foreground overflow-x-auto whitespace-nowrap scrollbar-none [&::-webkit-scrollbar]:hidden">
        <Link to="/" className="hover:text-primary transition-colors shrink-0">
          Home
        </Link>
        {/* On mobile the levels above the nearest one collapse to "…". The nearest
            category stays on screen: it is the way back to the listing, and on a
            product page every category link used to be hidden. */}
        {items.length > 2 && (
          <span className="flex items-center gap-2 md:hidden shrink-0">
            <ChevronRight className="h-3 w-3 shrink-0" />
            <span aria-hidden="true">…</span>
          </span>
        )}
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          const isCollapsed = i < items.length - 2;
          // Below md the row is one phone wide. The last crumb gives way first
          // but keeps a stub, then a long nearest category ("Bathroom Storage &
          // Linen Cabinets") ends in "…" instead of running off the row.
          const isNearest = i === items.length - 2;
          return (
            <span
              key={i}
              className={`items-center gap-2 ${
                isLast
                  ? "flex min-w-[3.5rem] shrink-[100] overflow-hidden md:min-w-0 md:shrink"
                  : isNearest
                  ? "min-w-0 md:shrink-0"
                  : "shrink-0"
              } ${isCollapsed ? "hidden md:flex" : "flex"}`}
            >
              <ChevronRight className="h-3 w-3 shrink-0" />
              {item.href ? (
                <Link
                  to={item.href}
                  className={`hover:text-primary transition-colors ${isNearest ? "min-w-0 truncate" : "shrink-0"}`}
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`text-foreground ${isLast ? "truncate max-w-[70vw] md:max-w-none" : ""}`}>{item.label}</span>
              )}
            </span>
          );
        })}

      </div>
    </div>
  );
};
